import type { TrackingFn } from '@change-corgi/core-react/tracking';

import { getNavigatorShareInterface } from '#src/app/shared/share/utils';

import { trackShareFailure, trackShareIntent, trackShareSuccess } from './track';

type Options = {
	trackingData: Record<string, string | number | boolean | undefined>;
	trackingEvents: {
		intent?: string;
		success: string;
		failure: string;
	};
};

export async function shareNative(
	data: ShareData,
	{ trackingEvents, trackingData }: Options,
	track: TrackingFn,
): Promise<boolean> {
	if (trackingEvents.intent) {
		trackShareIntent(trackingEvents.intent, trackingData, track);
	}

	const navigator = getNavigatorShareInterface();

	if (!navigator || !navigator.canShare(data)) {
		return false;
	}

	try {
		await navigator.share(data);
		trackShareSuccess(trackingEvents.success, trackingData, track);
		return true;
	} catch (e) {
		const error = e as Error;
		if (error.name === 'AbortError') {
			return false;
		}
		trackShareFailure(
			trackingEvents.failure,
			{
				...trackingData,
				errorName: error.name,
				errorMessage: error.message,
			},
			track,
		);
		return false;
	}
}
